import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FormInputField from 'src/components/common/formInputField';
import { useForm } from 'react-hook-form';
import { useSettingActions } from 'src/store/settings/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import ToastMessage from 'src/components/ToastContainer';
import { successMsg } from 'src/components/utilities/utils';
import { errorMsg } from 'src/components/utilities/utils';
import AttributeMapping from '../attributemapping/index';
import SecureInputField from 'src/components/common/secureInputField';
const ImisIntegration: React.FC = () => {
  const dispatch = useDispatch();
  const settingAction = useSettingActions(dispatch);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control
  } = useForm();

  const { imisIntegration, isIntegrationUpdated, message, error } = useSelector(
    (state: RootState) => {
      return {
        imisIntegration: state.setting.imisIntegration,
        isIntegrationUpdated: state.setting.isIntegrationUpdated,
        message: state.setting.message,
        error: state.setting.error
      };
    }
  );

  const [showApiPassword, setShowApiPassword] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);

  useEffect(() => {
    if (imisIntegration) {
      const transformedData = {
        ...imisIntegration,
        dateFrom: imisIntegration.dateFrom ? imisIntegration.dateFrom.split('T')[0] : ''
      };
      reset(transformedData);
    }
  }, [imisIntegration]);

  useEffect(() => {
    settingAction.getImisIntegrationRequest();
  }, []);

  useEffect(() => {
    if (isIntegrationUpdated) {
      successMsg(message);
      settingAction.resetSettingStateRequest();
    }
  }, [isIntegrationUpdated]);

  const onSubmit = (data: any) => {
    if (imisIntegration == undefined || imisIntegration.id == undefined) {
      settingAction.addImisIntegrationRequest(data);
    } else {
      const payloadData = {
        name: 'iMIS',
        updateData: [
          { op: 'replace', path: 'providerName', value: data.providerName },
          { op: 'replace', path: 'restClient', value: data.restClient },
          { op: 'replace', path: 'memberInfoIQA', value: data.memberInfoIQA },
          { op: 'replace', path: 'membershipGroupsIQA', value: data.membershipGroupsIQA },
          { op: 'replace', path: 'clientId', value: data.clientId },
          { op: 'replace', path: 'clientSecret', value: data.clientSecret },
          { op: 'replace', path: 'iMISVersion203plus', value: data.iMISVersion203plus },
          { op: 'replace', path: 'apiUser', value: data.apiUser },
          { op: 'replace', path: 'apiPassword', value: data.apiPassword },
          { op: 'replace', path: 'writeBackCECredits', value: data.writeBackCECredits },
          { op: 'replace', path: 'writeBackCEPath', value: data.writeBackCEPath },
          { op: 'replace', path: 'dateFrom', value: data.dateFrom }
        ]
      };
      settingAction.updateIntegrationRequest(payloadData);
    }
  };

  useEffect(() => {
    if (error) {
      errorMsg('Error');
      settingAction.resetSettingStateRequest();
    }
  }, [error]);

  return (
    <div>
      <ToastMessage />
      <div className="mb-6">
        <h2 className="font-semibold my-1">Integration</h2>
        <ol className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/integrations">Integration</Link>
          </li>
          <li>
            <strong> iMIS Integration</strong>
          </li>
        </ol>
        <Link to={`/integrations`}>
          <i className="fas fa-arrow-left mt-5"></i>
          <span className="ml-2">Go Back</span>
        </Link>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="dashboard-card p-5 w-5/6">
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Provider Name</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'providerName'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Rest Client</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'restClient'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Member Info IQA</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'memberInfoIQA'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Membership Groups IQA</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'membershipGroupsIQA'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>

        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Client Id</label>
          </div>
          <div className="md:w-8/12">
            <SecureInputField
              label={''}
              type={'text'}
              fieldName={'clientId'}
              control={control}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Client Secret</label>
          </div>
          <div className="md:w-8/12 relative">
            <SecureInputField
              label={''}
              type={showClientSecret ? 'text' : 'password'}
              fieldName={'clientSecret'}
              control={control}
              errors={''}
              isRequired={false}
            />
            <i
              className={`fas ${
                showClientSecret ? 'fa-eye-slash' : 'fa-eye'
                } cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2`}
              onClick={() => setShowClientSecret(!showClientSecret)}></i>
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">iMIS version 20.3+</label>
          </div>
          <div className="md:w-8/12">
            <div className="flex items-center">
              <div className="form-check form-switch pl-0 flex-items mb-2">
                <div className="relative">
                  <input
                    className="form-check-input switch-btn"
                    type="checkbox"
                    id="iMISVersion203plus"
                    {...register('iMISVersion203plus')}
                  />
                  <i className="fas fa-check checkbox-tick hidden"></i>
                  <i className="fas fa-times checkbox-cross"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Api User</label>
          </div>
          <div className="md:w-8/12">
            <SecureInputField
              label={''}
              type={'text'}
              fieldName={'apiUser'}
              control={control}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Api Password</label>
          </div>
          <div className="md:w-8/12 relative">
            <SecureInputField
              label={''}
              type={showApiPassword ? 'text' : 'password'}
              fieldName={'apiPassword'}
              control={control}
              errors={''}
              isRequired={false}
            />
            <i
              className={`fas ${
                showApiPassword ? 'fa-eye-slash' : 'fa-eye'
                } cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2`}
              onClick={() => setShowApiPassword(!showApiPassword)}></i>
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Write Back CE Credits</label>
          </div>
          <div className="md:w-8/12">
            <div className="flex items-center">
              <div className="form-check form-switch pl-0 flex-items mb-2">
                <div className="relative">
                  <input
                    className="form-check-input switch-btn"
                    type="checkbox"
                    id="writeBackCECredits"
                    {...register('writeBackCECredits')}
                  />
                  <i className="fas fa-check checkbox-tick hidden"></i>
                  <i className="fas fa-times checkbox-cross"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Write Back CE Path</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'writeBackCEPath'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Send Credits From Date</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'date'}
              fieldName={'dateFrom'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex items-center">
          <button type="submit" className="px-6 btn-primary w-28 mr-0 ml-3 mt-0">
            Save
          </button>
        </div>
      </form>
      <div className="dashboard-card p-5 w-5/6 mt-5">
        <AttributeMapping providerId="1" mappingType="1" />
      </div>
    </div>
  );
};

export default ImisIntegration;
